<template>
<div>
    <div class="common-label">{{label}}</div>
    <multiselect v-model="model" :options="value"
                 class="badge-wrapper"
                 track-by="value"
                 label="text"
                :searchable="false"
                :allowEmpty="true"
                :show-labels="false"
                :multiple="true"
                :placeholder="placeholder"
    >
    </multiselect>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: "UXMultiselectMultiple",
    components: {
        Multiselect
    },
    props: {
        label: String,
        placeholder: String,
        value: {default: [], type: Array }
    },
    computed: {
      model: {
        get: function () {
          return this.getMultiple(this.value);
        },
        set: function (newValue) {
          this.setMultiple(this.value, newValue);
        }
      }
    },
    methods: {
      getMultiple: function (array) {
        var values = array.filter( item => item.isSelected );
        return values;
      },
      setMultiple: function (array, newvalues) {
        array.forEach(function(obj) {
            obj.isSelected = false;
        });
        if(Array.isArray(newvalues)) {
          newvalues.forEach(function(obj) {
              obj.isSelected = true;
          });
        }
        var values = array.filter( item => item.isSelected );
        return values;
      }
    }
};
</script>
